export default "__VITE_ASSET__V2c4RSa$__"